import Vue from 'vue'
import Vuetify from 'vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'mdi' || 'fa'
  },
  theme: {
    themes: {
      light: {
        primary: '#2CB5A9',
        secondary: '#FFBB77'
      }
    }
  }
}

export default new Vuetify(opts)
